import React from 'react'
import { Link } from 'react-static'

import SectionTitle from 'components/Section-Title'
import ColorBar from 'components/Color-Bar'

import contentImageUrl from '../static/img/content-strategic-land-promotion.jpg'

class StrategicLandPromotion extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ColorBar />

        <div className="container container--layer-up">
          <div className="layout layout--img-left">
            <div className="layout__item parallax aspect-ratio--min-thirteen-ten" style={{ backgroundImage: `url(${contentImageUrl})`, backgroundSize: 'cover' }} />
            <div className="layout__item">
              <SectionTitle
                align="left"
                icon="icon-strategic-land-promotion.svg"
                title="Strategic Land Promotion"
              />
              <p>GDL have spent considerable time and effort promoting both employment and residential sites through the current plan process to include District, Borough and Neighbourhood plan procedures.</p>
              <p>Until now the Governments’ focus has been the delivery of houses. GDL  have and continue to seek more land to buy and/or promote employment use.</p>
              <p>We will provide an immediate planning overview view on your land for consideration.</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default StrategicLandPromotion;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Strategic-Land-Promotion.js